"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.config.title': 'Training Configuration',
    'trainer.config.basic': 'Basic Settings',
    'trainer.config.model.name': 'Model Name',
    'trainer.config.model.name.required': 'Model Name *',
    'trainer.config.model.name.placeholder': 'Enter a unique name for your model',
    'trainer.config.base.model': 'Base Model',
    'trainer.config.fine.tuning': 'Choose training method',
    'trainer.config.fine_tuning.lora_extension': 'LoRA Extension',
    'trainer.config.fine_tuning.fulltrain': 'Full Training',
    'trainer.config.advanced': 'Advanced Settings',
    'trainer.config.advanced.hide': 'Hide',
    'trainer.config.advanced.show': 'Show',
    'trainer.config.epochs': 'Epochs',
    'trainer.config.epochs.help': 'Number of training iterations (recommended: 10-50)',
    'trainer.config.learning.rate': 'Learning Rate',
    'trainer.config.learning.rate.help': 'Controls how quickly the model learns (recommended: 0.001)',
    'trainer.config.batch.size': 'Batch Size',
    'trainer.config.batch.size.help': 'Number of samples processed together',
    'trainer.config.validation.split': 'Validation Split',
    'trainer.config.validation.split.help': 'Percentage of data used for validation (0.2 = 20%)',
    'trainer.config.train': 'Start Training',
};
